import React, { useRef, useState, useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';

//Headlessui for MODAL
import { Dialog, Transition } from '@headlessui/react'

//Animation
import { useAutoAnimate } from '@formkit/auto-animate/react'

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Skeleton
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

//ICONS
import { BsCheck2Circle, BsXLg, BsTrash, BsPencil, BsFillExclamationTriangleFill, BsRecordCircleFill } from "react-icons/bs";

//APIS
import { donem, donemCreate, donemUpdate, donemAktif } from '../../../apis/donem'

//HELPERS
import upperCase from '../../../helpers/upperCase';

const DonemIslemleri = () => {
    const reduxData = useSelector((state) => state.auth)
    const [animationParent] = useAutoAnimate()
    const [loading, setLoading] = useState(false) // Skleton için kullanılacak
    const [openModal, setOpenModal] = useState(false) // Skleton için kullanılacak


    //REFS
    const donemAdiRef = useRef()
    const donemBaslangicTarihiRef = useRef()
    const donemBitisTarihiRef = useRef()


    //STATES
    const [donemAdi, setDonemAdi] = useState("")
    const [donemId, setDonemId] = useState()
    const [donemBaslangicTarihi, setDonemBaslangicTarihi] = useState("")
    const [donemBitisTarihi, setDonemBitisTarihi] = useState("")
    const [donemAktifId, setDonemAktifId] = useState(0)

    const [donemLIST, setDonemLIST] = useState([])

    // eslint-disable-next-line
    const [formDurum, setFormDurum] = useState(false) // false Yeni Kayıt, true Kayıt Güncelleme

    const tarihCevir = (tarih) => {
        const dateParts = tarih.split('-');
        const day = dateParts[0];
        const month = dateParts[1];
        const year = dateParts[2];
        return `${year}-${month}-${day}`
    }



    const handleFormControl = () => {
        console.log(donemAdi + '-' + donemBaslangicTarihi + "-" + donemBitisTarihi)

        if (donemAdi === "") {
            donemAdiRef.current.focus()
            return toast.error("Dönem adı giriniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }
        if (donemBaslangicTarihi === "") {
            donemBaslangicTarihiRef.current.focus()
            return toast.error("Dönemin başlayacağı tarihi giriniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }
        if (donemBitisTarihi === "") {
            donemBitisTarihiRef.current.focus()
            return toast.error("Dönemin biteceği tarihi giriniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }

        if (formDurum === false) {
            //yeni kayıt
            handleFormSave()
        } else {
            //kayıt düzenleme
            handleFormUpdate()
        }

    }

    const handleFormSave = async () => {
        let data = {
            enstituId: reduxData.userEnstituId,
            donemName: upperCase(donemAdi.trim()),
            donemBasTar: donemBaslangicTarihi,
            donemBisTar: donemBitisTarihi,
        }
        console.log(data)
        let result = await donemCreate(data)
        if (result.status === 200) {
            toast.success("Dönem oluşturuldu", {
                position: toast.POSITION.TOP_CENTER
            });
            getDonemLIST()
            handleClearForm()
        } else {
            return toast.error(result.response.data.message, {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    const handleFormUpdate = async () => {
        let data = {
            enstituId: reduxData.userEnstituId,
            donemName: upperCase(donemAdi.trim()),
            donemBasTar: donemBaslangicTarihi,
            donemBisTar: donemBitisTarihi,
        }
        let result = await donemUpdate(donemId, data)
        if (result.status === 200) {
            toast.success("Dönem güncellendi", {
                position: toast.POSITION.TOP_CENTER
            });
            getDonemLIST()
            handleClearForm()
        } else {
            return toast.error(result.response.data.message, {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    const handleFormDelete = async () =>{
        let data = {
            donemIsDelete: true,
        }
        let result = await donemUpdate(donemId, data)
        if (result.status === 200) {
            toast.success("Dönem silindi", {
                position: toast.POSITION.TOP_CENTER
            });
            getDonemLIST()
            handleClearForm()
        } else {
            return toast.error(result.response.data.message, {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    const handleClearForm = () => {
        setDonemId()
        setDonemAdi("")
        setDonemBaslangicTarihi("")
        setDonemBitisTarihi("")
        setFormDurum(false)
        setOpenModal(false)
        getDonemAktif()
    }


    //FUNCTIONS
    const getDonemLIST = async () => {
        setLoading(true)
        let result = await donem()
        console.log(result.data)
        if (result.status === 200) {
            setDonemLIST(result.data)
        }
        setLoading(false)
    }

    const getDonemAktif = async () => {
        let result = await donemAktif()
        if (result.status === 200) {
            console.log(result?.data?.donemActive?.donemId)
            setDonemAktifId(result?.data?.donemActive?.donemId)
        }else{
            setDonemAktifId(0)
        }
    }

    useEffect(() => {
        getDonemLIST()
        getDonemAktif()
    }, []);

    return (
        <>
            <ToastContainer />
            <main className='text-slate-500 text-sm transition-all'>
                <div className="py-5">
                    <div className="max-w-6xl px-4 sm:px-6 md:px-8">
                        <div className='container mx-auto'>
                            <h1 className='page-title leading-6 font-normal text-lg mb-6 text-slate-500'>Dönem İşlemleri</h1>
                        </div>
                        <div className='container mx-auto space-y-4'>
                            <div className='kapsama relative w-full flex flex-col lg:flex-row gap-4'>

                                {/* DÖNEM EKLEME */}
                                <div className='sag w-full'>
                                    <div className='bg-white rounded-lg p-4 min-h-0 lg:min-h-[calc(100vh_-_200px)]'>
                                        <h1 className='text-lg mb-4'>Dönem Ekle</h1>
                                        <div className='flex flex-col items-start gap-4'>
                                            <div className='w-full'>
                                                <label onClick={() => { donemAdiRef.current.focus() }}>Dönem Adı</label>
                                                <input ref={donemAdiRef} value={donemAdi} onChange={(e) => { setDonemAdi(e.target.value) }} type='text' placeholder='' className='sd-form-input' />
                                            </div>
                                            <div className='w-full flex flex-wrap md:flex-nowrap gap-x-4 space-y-4 md:space-y-0'>
                                                <div className='w-full md:w-1/2 space-y-4 text-slate-500'>
                                                    <div>
                                                        <label onClick={() => { donemBaslangicTarihiRef.current.focus() }}>Başlangıç Tarihi</label>
                                                        <input ref={donemBaslangicTarihiRef} value={donemBaslangicTarihi} onChange={(e) => { setDonemBaslangicTarihi(e.target.value) }} type='date' placeholder='' className='sd-form-input' />
                                                    </div>
                                                </div>
                                                <div className='w-full md:w-1/2 space-y-4 text-slate-500'>
                                                    <div>
                                                        <label onClick={() => { donemBitisTarihiRef.current.focus() }}>Bitiş Tarihi</label>
                                                        <input ref={donemBitisTarihiRef} value={donemBitisTarihi} onChange={(e) => { setDonemBitisTarihi(e.target.value) }} type='date' placeholder='' className='sd-form-input' />
                                                    </div>
                                                </div>

                                            </div>
                                            <div className='w-full flex gap-x-4'>
                                                <div className='text-right'>
                                                    <button
                                                        onClick={() => handleFormControl()}
                                                        disabled={donemAdi === "" ? true : false}
                                                        className='w-full text-xs h-10 inline-flex items-center gap-x-2 text-white bg-slate-500 disabled:bg-slate-300  hover:bg-slate-500/80 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                        <BsCheck2Circle className='text-lg' />
                                                        {formDurum ? "DÜZENLE" : "KAYDET"}
                                                    </button>
                                                </div>
                                                <div className='text-right'>
                                                    <button
                                                        onClick={() => handleClearForm()}
                                                        disabled={donemAdi === "" ? true : false}
                                                        className='w-full text-xs h-10 inline-flex items-center gap-x-2 text-white bg-red-400 disabled:bg-red-300 hover:bg-red-500 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-red-300 transition-all'>
                                                        <BsXLg className='text-lg' />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='birimlistesi mt-4'>
                                            <h1 className='text-lg mb-4'>Dönem Listesi</h1>

                                            <ul className='flex flex-col'>
                                                <div ref={animationParent}>
                                                    {
                                                        loading ? <Skeleton baseColor="#e2e8f0" width="100%" count={3} height={20} /> :
                                                            (
                                                                donemLIST?.length !== 0 ? (
                                                                    donemLIST?.map((item, key) => (
                                                                        <li key={key} className='w-full mb-2 bg-slate-100 hover:bg-slate-200 hover:cursor-pointer rounded-md p-2 flex flex-col  items-centerspace-y-1 md:flex-row md:items-center md:space-x-4'>
                                                                            {
                                                                                //console.log(donemAktifId)
                                                                                donemAktifId === item.donemId ? (
                                                                                    <div><BsRecordCircleFill className='text-green-600'/></div>
                                                                                ) : (
                                                                                    <div><BsRecordCircleFill className='text-red-600'/></div>
                                                                                )
                                                                            }
                                                                            <div className='flex-1'>{item.donemName}</div>
                                                                            <div className='flex-1'>Başlama : {item.donemBasTar}</div>
                                                                            <div className='flex-1'>Bitiş : {item.donemBisTar}</div>
                                                                            <div className='flex-1 md:text-right space-x-4'>
                                                                                <button
                                                                                    onClick={() => {
                                                                                        setFormDurum(true)
                                                                                        setDonemId(item.donemId)
                                                                                        setDonemAdi(item.donemName)
                                                                                        setDonemBaslangicTarihi(tarihCevir(item.donemBasTar))
                                                                                        setDonemBitisTarihi(tarihCevir(item.donemBisTar))
                                                                                    }}
                                                                                    className='text-xs inline-flex items-center gap-x-1 text-white bg-slate-500 border-transparent border hover:bg-slate-500/80 px-2 py-1 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                                                    <BsPencil />Düzenle
                                                                                </button>
                                                                                <button
                                                                                    onClick={() => {
                                                                                        setDonemId(item.donemId)
                                                                                        setOpenModal(true)
                                                                                    }}
                                                                                    className='text-xs inline-flex items-center gap-x-1 text-white bg-red-500 border-transparent border hover:bg-red-500/80 px-2 py-1 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-red-300 transition-all'>
                                                                                    <BsTrash />Sil
                                                                                </button>
                                                                            </div>
                                                                        </li>
                                                                    ))
                                                                ) : (
                                                                    <>
                                                                        <li>Kayıtlı dönem bulunmamaktadır.</li>
                                                                    </>
                                                                )
                                                            )
                                                    }
                                                </div>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Transition.Root show={openModal} as={Fragment}>
                <Dialog as="div" className="relative z-50" onClose={setOpenModal}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                        <button
                                            type="button"
                                            className="rounded-md bg-white text-gray-400 hover:text-gray-500 "
                                            onClick={() => setOpenModal(false)}
                                        >
                                            <span className="sr-only">Close</span>
                                            <BsXLg className="h-6 w-6" aria-hidden="true" />
                                        </button>
                                    </div>
                                    <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <BsFillExclamationTriangleFill className="h-6 w-6 text-red-600" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                            <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                                                UYARI!
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                <p className="text-sm text-gray-500">
                                                    Seçili Anabilim/Anasanat Dalını Silmek Üzeresiniz. Emin misiniz?
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                            onClick={() =>
                                                handleFormDelete()
                                            }
                                        >
                                            Evet
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                            onClick={() => {
                                                setOpenModal(false)
                                                setDonemId()
                                            }}
                                        >
                                            İptal
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
}

export default DonemIslemleri;
